
import { get, post } from '@/common/request/index';

/**
 * 企微-自建应用：获取企微web登录组件参数
 * https://yapi.lanhanba.com/project/378/interface/api/92449
 */
export function getQWLoginConfig() {
  return get(`/tp/wx/internal/oauth2/getWebLoginConfig`, {}, {
    isMirage: true,
    needHint: true,
  });
}


/**
 * 企微-企微授权登录
 * https://yapi.lanhanba.com/project/378/interface/api/78007
 */
export function loginQW(params) {
  return post(`/wxOauth2/login`, params, {
    isMirage: true,
    needHint: true,
  });
}

/**
 * 企微登录-获取授权网址
 * https://yapi.lanhanba.com/project/378/interface/api/59324
 */
export function getWeComAuthorizeLink(params?: any) {
  return post(`/tp/wx/oauth2/authorize`, params, {
    isMirage: true,
    needHint: true,
  });
}
